import React, { Component } from "react";
import {Row,Col,Button,Modal,Container,Form,} from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

class EditCountryCrncy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        countryId: this.props.ItemList
          ? this.props.ItemList.countryId.id
          : null,
        currencyId: this.props.ItemList
          ? this.props.ItemList.currencyId.id
          : null,
        id: this.props.ItemList ? this.props.ItemList.id : null,
        // isActive: this.props.ItemList ? this.props.ItemList.isActive : null,
      },
    };
    this.submit = this.submit.bind(this);
    this.selectCountry = this.selectCountry.bind(this);
    this.selectCurrency = this.selectCurrency.bind(this);
  }

  submit() {
    const value = this.state.value;
  

    this.props.EditCntryCurency(this.state.value);
    this.props.closeEdtModel();
    this.props.resetPage();
  }

  selectCountry(event) {
    this.setState({
      value: { ...this.state.value, countryId: event.target.value },
    });
  }

  selectCurrency(event) {
    this.setState({
      value: { ...this.state.value, currencyId: event.target.value },
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        countryId:
          nextProps.ItemList.countryId && nextProps.ItemList.countryId.id,
        currencyId:
          nextProps.ItemList.currencyId && nextProps.ItemList.currencyId.id,
        // isActive: nextProps.ItemList && nextProps.ItemList.isActive,
        id: nextProps.ItemList && nextProps.ItemList.id,
      },
    });
  }

  render() {
 
    return (
      <div>
        <div>
          <Modal
            show={this.props.showEditModal}
            onHide={this.props.closeEdtModel}
            animation={false}
            size="md"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Country Currency</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <Row>
                  <Col lg={12}>
                    <Form>
                      <div style={{ maxWidth: 250, margin: "auto" }}>
                        <Row>
                          <Form.Group
                            style={{
                              marginBottom: 15,
                              width: "100%",
                              height: 35,
                            }}
                          >
                            <Form.Control
                              as="select"
                              onChange={this.selectCountry}
                            >
                              {this.props.CountrysList &&
                                this.props.CountrysList.map(
                                  (item, i) =>
                                    this.state.value.countryId === item.id && (
                                      <option key={i} value={item.id}>
                                        {item.name}
                                      </option>
                                    )
                                )}
                              {this.props.CountrysList &&
                                this.props.CountrysList.map(
                                  (item, i) =>
                                    this.state.value.countryId !== item.id && (
                                      <option key={i} value={item.id}>
                                        {item.name}
                                      </option>
                                    )
                                )}
                            </Form.Control>
                          </Form.Group>
                        </Row>

                        <Row>
                          <Form.Group
                            style={{
                              marginBottom: 15,
                              width: "100%",
                              height: 35,
                            }}
                          >
                            <Form.Control
                              as="select"
                              onChange={this.selectCurrency}
                            >
                              {this.props.CurrencyList &&
                                this.props.CurrencyList.map(
                                  (item, i) =>
                                    this.state.value.currencyId === item.id && (
                                      <option key={i} value={item.id}>
                                        {item.name}
                                      </option>
                                    )
                                )}
                              {this.props.CurrencyList &&
                                this.props.CurrencyList.map(
                                  (item, i) =>
                                    this.state.value.currencyId !== item.id && (
                                      <option key={i} value={item.id}>
                                        {item.name}
                                      </option>
                                    )
                                )}
                            </Form.Control>
                          </Form.Group>
                        </Row>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </Modal.Body>

            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
              <Button onClick={this.submit}>Submit</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
export default EditCountryCrncy;
